import CoreEventHero from './CoreEventHero';

export { type CoreEventHeroProps } from './CoreEventHero';
export default CoreEventHero;
